/* eslint-disable import/newline-after-import */
/* eslint-disable import/order */
import {createRoot} from 'react-dom/client';
import 'rxjs';
import 'rxjs-compat'; // Should be removed once migration is done https://auth0.com/blog/whats-new-in-rxjs-6/
import 'web-app/setup/prototype-extensions/load-prototype-extensions';
import extendNumber from 'web-app/setup/prototype-extensions/number';
extendNumber();

import 'core-js/actual/object/has-own'; // react-markdown requires this – at least while we have to support iOS versions <15.4
import 'core-js/actual/structured-clone'; // Safari 15.3 and below does not support structuredClone, and it is used by @pdfme/ui
// Quill 2's getSemanticHTML uses String.prototype.replaceAll (Safari 13.4+) on every save, and quill core uses
// Object.fromEntries (Safari 12.1+). The prod swc rule's `usage` mode already auto-injects these for quill, so on
// this webpack entry they are a backstop (mirrors famly/apps/web/src/main.tsx, where rspack does not polyfill).
import 'core-js/actual/string/replace-all';
import 'core-js/actual/object/from-entries';

import {setupResizeObserverBorderBoxSize} from 'web-app/setup/resize-observer-border-box-size-setup';
// react-window@2 reads `ResizeObserverEntry.borderBoxSize[0]`, which is undefined on Safari/iOS < 15.4 (APP-PRODUCTION-5SE)
setupResizeObserverBorderBoxSize();

import setupSentry from 'web-app/shared/sentry-setup';
import {setupMoment} from 'web-app/setup/moment-setup';
import setupNumeral from 'web-app/setup/numeral-setup';
import ENV from 'web-app/config/environment';
import {installFindDOMNodeShim} from '@famly/vet_ts-utils_react-dom-shim';
import {shouldReloadAfterAppChunkLoadError} from 'web-app/setup/should-reload-after-app-chunk-load-error';

import {withTranslationsReady$} from './react/routes/application-route-helpers/with-translations';

// React 19 removed ReactDOM.findDOMNode, which some legacy dependencies (react-transition-group)
// still call internally. Re-expose it before anything renders.
installFindDOMNodeShim();

setupMoment();
setupNumeral();
setupSentry(ENV as any);

withTranslationsReady$.subscribe(() => {
    import('./webpack-react-app')
        .then(App => {
            const root = createRoot(document.getElementById('webpack-root')!);
            root.render(<App.default />);
        })
        .catch(error => {
            if (shouldReloadAfterAppChunkLoadError(error)) {
                window.location.reload();
            }
        });
});
